import * as v from 'valibot';
import Ajax from '../util/ajax';
import { nexaReceiverSchema } from '../types/NexaReceiver';
import { nexaReceiverUpdated } from '../reducers/nexaReceiversSlice';
export function saveNexaReceiver(r, okCallback, errorCallback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/nexa-receiver/' + r.id;
        const obj = Object.assign(Object.assign({}, r), { codes: JSON.stringify(r.codes) });
        ajax.post(url, obj, data => {
            const res = v.safeParse(nexaReceiverSchema, data);
            if (res.success) {
                dispatch(nexaReceiverUpdated(res.output));
                okCallback();
            }
            else {
                console.error(v.summarize(res.issues));
                if (errorCallback != undefined) {
                    errorCallback();
                }
            }
        });
    };
}
